/** @type {(() => void) | null} */
let onSystemMessageLogged = null;

export function setOnSystemMessageLogged(handler) {
  onSystemMessageLogged = typeof handler === "function" ? handler : null;
}

export function notifySystemMessageLogged() {
  onSystemMessageLogged?.();
}
